import axios from 'axios';
import { USER_LOCAL_STORAGE_KEY } from 'contexts/auth';
import { BASE_SPINDLE_BE_URL } from 'utils/constants';

type reqParams = {
  url: string;
  headers?: object;
  body?: object;
};

export const makeGet = ({ url, headers }: reqParams): Promise<object> => {
  return axios.get(`${BASE_SPINDLE_BE_URL}/${url}`, { headers: { ...headers } });
};

export const makePost = ({ url, headers, body }: reqParams): Promise<object> => {
  const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY));
  const accountId = user?.accountId;
  const defaultHeaders = {
    ...headers,
    'x-site-context': JSON.stringify({ account: accountId }),
  };
  const resp = axios
    .post(`${BASE_SPINDLE_BE_URL}${url}`, body, { headers: defaultHeaders })
    .catch(error => error.response);

  return resp;
};
